import React, { useState } from 'react';
import { Box, Grid, Typography, TextField, Button, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';

const LabelWithColon = ({ label }) => (
  <Grid container wrap="nowrap" spacing={0.5}>
    <Grid item>
      <Typography>
        <b>{label}</b>
      </Typography>
    </Grid>
    <Grid item>
      <Typography>
        <b>:</b>
      </Typography>
    </Grid>
  </Grid>
);

export default function ReverseReceipt() {
  const [receiptNo, setReceiptNo] = useState('');
  const [detailsFetched, setDetailsFetched] = useState(false);

  const handleClick = () => {
    if (receiptNo === '') {
      alert('Please enter receipt no');
      return;
    }
    setDetailsFetched(true);
  };
  return (
    <Box p={3}>
      {/* Header Selection */}
      <Grid container spacing={2} alignItems="center" justifyContent="space-between">
        <Grid>
          <RadioGroup row defaultValue="reverse" name="receipt-type">
            <FormControlLabel value="new" control={<Radio />} label="New Receipt" />
            <FormControlLabel value="reverse" control={<Radio />} label="Reverse Receipt" />
            <FormControlLabel value="refund" control={<Radio />} label="Refund Receipt" />
          </RadioGroup>
        </Grid>

        {/* Receipt No and Go Button */}
        <Grid style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }} mb={2}>
          <Typography>
            <b>
              {' '}
              <span style={{ color: 'red' }}>*</span> Receipt No
            </b>
          </Typography>
          <TextField size="small" value={receiptNo} onChange={e => setReceiptNo(e.target.value)} />
          <Button variant="contained" onClick={handleClick}>
            GO
          </Button>
        </Grid>
      </Grid>

      {detailsFetched && (
        <>
          {/* Two Column Info Layout */}
          <Grid container spacing={2} style={{ marginTop: '2rem' }}>
            {/* Left Column */}
            <Grid item xs={6}>
              {[
                ['Receipt Type', 'CD'],
                ['Corporate', 'NISOL Manufacturing Company Private Limited'],
                ['SBIG Branch Code', 'SBI General Insurance Co Ltd - Baroda  [00023]'],
                ['Receive Amount', '-197,977.00'],
                ['Amount', '-197,977.00'],
                ['Instrument Date', '2025-07-25'],
                ['Branch', 'State Bank of India'],
              ].map(([label, value]) => (
                <Grid container spacing={2} alignItems="center" key={label}>
                  <Grid item xs={4}>
                    <LabelWithColon label={label} />
                  </Grid>
                  <Grid item xs={8}>
                    <Typography>{value}</Typography>
                  </Grid>
                </Grid>
              ))}

              {/* Note Field */}
              <Grid container spacing={2} alignItems="flex-start" mt={1}>
                <Grid item xs={4}>
                  <LabelWithColon label="Note" />
                </Grid>
                <Grid item xs={8}>
                  <TextField fullWidth multiline rows={2} placeholder="Enter note here" size="small" />
                </Grid>
              </Grid>
            </Grid>

            {/* Right Column */}
            <Grid item xs={6}>
              {[
                ['Insurance Company', 'SBI Genaral Insurance Company Ltd'],
                ['Account No', 'C17595'],
                ['Deposit Bank', 'SBI Online Premium Collection A/c 8754'],
                ['Mode of Payment', 'EFT'],
                ['EFT No', '200002568'],
                ['Bank', 'State Bank of India'],
              ].map(([label, value]) => (
                <Grid container spacing={2} alignItems="center" key={label}>
                  <Grid item xs={4}>
                    <LabelWithColon label={label} />
                  </Grid>
                  <Grid item xs={8}>
                    <Typography>{value}</Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>

          {/* Footer Buttons */}
          <Box style={{ display: 'flex', gap: '1rem', justifyContent: 'end' }} mt={4}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setReceiptNo('');
                setDetailsFetched(false);
              }}>
              CLOSE
            </Button>
            <Button variant="contained" color="primary">
              SUBMIT
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
}
